import keyMirror from 'keymirror';

const types = keyMirror({
	REFRESH_CHECKIN_RECORD: null,
	UPDATE_RECORD_ATTR: null,
});

export default types;



// WEBPACK FOOTER //
// ./src/constants/CheckinConstants.js